import { Card, CardTitle, CardDescription } from "../ui/card";
import { useDynamicContent, getSocialLinks } from "../../lib/dynamicContent";
import { SocialHoverGrid } from "./SocialHoverGrid";

interface SocialsGridProps {
  t: any;
}

export function SocialsGrid({ t }: SocialsGridProps) {
  const { socials: dynamicSocials } = useDynamicContent();
  const socials = getSocialLinks(dynamicSocials);

  // Dynamic social link lookup with sensible default fallbacks
  const getSocialUrl = (platformName: string, fallbackUrl: string) => {
    const found = socials.find(
      s => s.icon === platformName || s.name.toLowerCase().includes(platformName.toLowerCase())
    );
    return found ? found.url : fallbackUrl;
  };

  return (
    <Card id="socials-card" className="border border-border/40 bg-card/45 backdrop-blur-md p-6 md:p-8 space-y-6 shadow-sm overflow-hidden h-full flex flex-col">
      <div className="text-center md:text-left space-y-1">
        <CardTitle className="text-2xl font-extrabold text-brand-primary">{t.subtabSocials}</CardTitle>
        <CardDescription className="text-xs font-semibold text-muted-foreground">{t.socialSubtitle}</CardDescription>
      </div>

      {/* Premium Hero Interactive Socials Widget */}
      <div className="flex-1 flex items-center justify-center py-6">
        <SocialHoverGrid getSocialUrl={getSocialUrl} />
      </div>
    </Card>
  );
}

export default SocialsGrid;

